import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { VersionResponse } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MiscEndpoints extends ApiBase {
  public getVersion(): Observable<VersionResponse> {
    return this.get<VersionResponse>('/version');
  }
}
